'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAuthHeader = undefined;
exports.setChatConfig = setChatConfig;
exports.getChatConfig = getChatConfig;
exports.getCurrentTimeStampInUnix = getCurrentTimeStampInUnix;
exports.genUUID = genUUID;
exports.ajax = ajax;

var _constants = require('./constants');

var Constants = _interopRequireWildcard(_constants);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _v = require('uuid/v1');

var _v2 = _interopRequireDefault(_v);

var _userservice = require('../services/userservice');

var _userservice2 = _interopRequireDefault(_userservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var chatConfig = {};

function setChatConfig(config) {
    chatConfig = config;
}

function getChatConfig() {
    return chatConfig;
}

function getCurrentTimeStampInUnix() {
    return (0, _moment2.default)().valueOf();
}

function genUUID() {
    return (0, _v2.default)().replace(/-/g, "");
}

var getAuthHeader = exports.getAuthHeader = function getAuthHeader() {
    var header = Constants.HEADER;
    if (_userservice2.default.getAccessToken()) {
        header = Object.assign({}, Constants.HEADER, { Authorization: 'Bearer: ' + _userservice2.default.getAccessToken() });
    }
    return header;
};

var getHeader = function getHeader() {
    return Constants.HEADER;
};

function ajax(url, method) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var appendBaseUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    return new Promise(function (resolve, reject) {
        var apiUrl = url;
        if (appendBaseUrl) apiUrl = window.sfChat.baseApiUrl + url;

        var headers = getAuthHeader();
        var body = {
            method: method,
            headers: headers
        };
        if (data) {
            body.body = JSON.stringify(data);
        }
        fetch(apiUrl, body).then(function (res) {
            switch (res.status) {
                case 500:
                    console.error('Some server error');
                    reject(res);
                    break;
                case 401:
                    localStorage.removeItem(Constants.NS_USER);
                    // alert("Something went wrong try again")
                    console.error('Unauthorized');
                    reject(res);
                    break;
                case 400:
                    // alert("Something went wrong try again")
                    console.warn('Bad Request');
                    reject(res);
                    break;
            }
            resolve(res.json());
        }).catch(function (err) {
            if (err.constructor === {}.constructor)
                // if (typeof err === 'object')
                reject(err.json());else reject(err);
        });
    });
}


// WEBPACK FOOTER //
// ../chat/lib/common/helpers.js